import type { ReactNode } from 'react';
import { Check } from 'lucide-react';
import { cn } from '@ai-tutor/ui';

/** A section's "read" mark, set by the student. */
export function ReadCheckbox({
  checked,
  onChange,
  label,
  disabled = false,
  children,
  className,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Names the box for a screen reader when `children` does not. */
  label?: string;
  disabled?: boolean;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <button
      type='button'
      role='checkbox'
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'inline-flex items-center gap-2 rounded-md text-sm text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-default disabled:opacity-50',
        className
      )}
    >
      <span
        aria-hidden
        className={cn(
          'flex h-5 w-5 shrink-0 items-center justify-center rounded border-2 transition-colors',
          checked
            ? 'border-brand-500 bg-brand-500 text-white dark:border-primary dark:bg-primary dark:text-primary-foreground'
            : 'border-foreground/30 bg-transparent'
        )}
      >
        {checked && <Check className='h-3.5 w-3.5' strokeWidth={3} />}
      </span>
      {children}
    </button>
  );
}
